import React from "react";
import { OpenInNew } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { envConfig } from "utils/envConfig";
import type { CloudSubscriptionDto } from "client/api-v2";

interface CloudSubscriptionActionsProps {
  cloudSubscription: CloudSubscriptionDto | null;
  loading: boolean;
}

export function CloudSubscriptionActions({ cloudSubscription, loading }: CloudSubscriptionActionsProps) {
  const telemetryUrl = cloudSubscription?.serial
    ? `https://app.snowflake.com/rh51976/pv38481/#/streamlit-apps/PROD_MODEL.COMMERCIAL.%22Account%20Usage%20Dashboard%22/!/license?streamlit-license_id=${cloudSubscription.serial}`
    : "";

  // Build instance URL from DNS prefix - assumes octopus.app domain
  const instanceUrl = cloudSubscription?.dnsPrefix ? `https://${cloudSubscription.dnsPrefix}.octopus.app` : "";

  const cloudPortalUrl = cloudSubscription?.serial
    ? `${envConfig.OctopusCloudPortalDomain}/cloud-subscriptions/${cloudSubscription.serial}`
    : "";

  return (
    <Stack direction="row" spacing={2}>
      <Button
        variant="contained"
        component="a"
        target="_blank"
        href={telemetryUrl || undefined}
        disabled={loading || !telemetryUrl}
        rel="noopener noreferrer"
      >
        Telemetry <OpenInNew fontSize="small" sx={{ paddingLeft: 1 }} />
      </Button>
      <Button
        variant="contained"
        component="a"
        target="_blank"
        href={cloudPortalUrl || undefined}
        disabled={loading || !cloudPortalUrl}
        rel="noopener noreferrer"
      >
        Cloud Portal <OpenInNew fontSize="small" sx={{ paddingLeft: 1 }} />
      </Button>
      <Button
        variant="contained"
        component="a"
        target="_blank"
        href={instanceUrl || undefined}
        disabled={loading || !instanceUrl || !cloudSubscription?.isInstanceProvisioned}
        rel="noopener noreferrer"
      >
        Instance <OpenInNew fontSize="small" sx={{ paddingLeft: 1 }} />
      </Button>
    </Stack>
  );
}
